import { useCallback, useEffect, useState } from 'react';

import { getAuthData } from '@/data/service/authService';
import type { FeatureName } from '../types';
import { useFeatureTourLocalStorage } from './useFeatureTourLocalStorage';

export const useFeatureTourVisibility = (featureName: FeatureName) => {
  const [openFeatureTour, setOpenFeatureTour] = useState<boolean>(false);
  const { user } = getAuthData();
  const { featureTourKeyNotFound, setFeatureTourKey } =
    useFeatureTourLocalStorage({
      userId: user?.id,
      featureName: featureName,
    }) || false;

  useEffect(() => {
    if (featureTourKeyNotFound) {
      setOpenFeatureTour(true);
    }
  }, [featureTourKeyNotFound, setFeatureTourKey]);

  const handleDismissTour = useCallback(async () => {
    setFeatureTourKey(false);
    setOpenFeatureTour(false);
  }, [setFeatureTourKey, setOpenFeatureTour]);

  return {
    openFeatureTour,
    setOpenFeatureTour,
    handleDismissTour,
  };
};
